// Teal is the chart accent; violet and amber are reserved for the casino and sport verticals
export const SERIES_COLORS = {
  total: '#14b8a6',
  totalNegative: '#e11d48',
  casino: '#8b5cf6',
  sport: '#f59e0b'
};

export const VERTICAL_STYLES = {
  casino: { dot: 'bg-violet-500' },
  sport: { dot: 'bg-amber-500' }
};

export const VALUE_TONE = {
  positive: 'text-emerald-600 dark:text-emerald-400',
  negative: 'text-rose-600 dark:text-rose-400',
  zero: 'text-gray-900 dark:text-white'
};

/** Green for positive GGR, red for negative; amounts that round to zero stay neutral. */
export const valueTone = (value) => {
  if (!(Math.abs(value) >= 0.005)) return VALUE_TONE.zero;
  return value > 0 ? VALUE_TONE.positive : VALUE_TONE.negative;
};
